<script>
import axios from 'axios'
import {
  formatPrettyDateTimeshort,
  getDateTimeWithLocalOffsetAsISO,
} from '@utils/data/date-time'

import {
  infoDetailsMethods,
  filtersComputed,
  filtersMethods,
  actionsMethods,
  deviceActivityComputed,
  deviceEventCurrentMethods,
} from '@state/helpers'

import toggle from '@utils/design/toggle-info'

export default {
  props: {
    changedActivityEvents: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      search: '',
    }
  },

  computed: {
    ...deviceActivityComputed,
    ...filtersComputed,

    filteredActivities: function() {
      return this.cachedActivities.filter((activity) => {
        if (this.search.length > 0) {
          return activity.name.toLowerCase().includes(this.search.toLowerCase())
        } else {
          return this.cachedActivities
        }
      })
    },

    dateRangeSelected: function() {
      return this.changedActivityEvents.values[0]
    },
  },

  methods: {
    ...infoDetailsMethods,
    ...actionsMethods,
    ...deviceEventCurrentMethods,
    ...filtersMethods,

    updateActivity(activity) {
      axios
        .put('/api/services/app/DeviceEvent/UpdateActivity', {
          deviceId: this.$route.params.deviceId,
          activityId: activity.id,
          start: getDateTimeWithLocalOffsetAsISO(this.dateRangeSelected.start),
          end: getDateTimeWithLocalOffsetAsISO(this.dateRangeSelected.end),
        })
        .then((response) => {
          this.setactivityChangedFilter({
            activityChanged: Math.floor(Math.random() * 1000 + 1),
          })

          toggle()

          this.changeDeviceActivities({ reset: true })
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$router.push({
              name: 'Login',
              params: { resource: 'Device State History' },
            })
          }
          return null
        })
    },

    formatDate(date) {
      return formatPrettyDateTimeshort(date)
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      class="card list-group card-body info-card  mb-0 pl-0 pr-0 pt-2 pb-2 clearfix"
    >
      <b-form-group class="filter">
        <label
          for="name"
          class="w-100 pt-0 mt-0 font-weight-bold text-uppercase text-muted"
          >Search by Activity Name</label
        >
        <b-form-input
          v-model="search"
          class=" mb-2"
          placeholder="Activity Name..."
          type="text"
        ></b-form-input>
      </b-form-group>

      <button
        v-for="activity in filteredActivities"
        :key="activity.id"
        type="button"
        class="font-weight-bold text-uppercase list-group-item list-group-item-action text-uppercase"
        @click="updateActivity(activity)"
      >
        {{ activity.name }}
        <br />
        <span>
          <b-badge
            class="mr-2 text-black"
            :variant="activity.planned == true ? 'success' : 'danger'"
          >
            Planned
          </b-badge>
          <b-badge
            class="mr-2  text-black"
            :variant="activity.available == true ? 'success' : 'danger'"
            >Available
          </b-badge>
        </span>
      </button>
    </b-card-body>
  </div>
</template>

<style lang="css">
.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}
.dateRange {
  cursor: pointer;
}
.dateRange :hover {
  background-color: #181717;
}
.close-activity i{
  cursor: pointer;
}
</style>
